import { joinPath } from '../../core/utils';
import type { ImageBlockOptions, ImagePaths } from './types';

/**
 * 按交付类型 binding.options 生成镜像表单路径。
 * 各交付类型 URL / key 字段不同，通过 imageFieldPrefix、imageKeyField、imageUrlField 配置。
 */
export function resolveImagePaths(prefix: string, options?: ImageBlockOptions): ImagePaths {
  const imagePrefix = options?.imageFieldPrefix ?? (prefix ? joinPath(prefix, 'image') : 'basic.image');

  return {
    imagePrefix,
    imageKey: options?.imageKeyField ?? `${imagePrefix}.key`,
    imageUrl: options?.imageUrlField ?? `${imagePrefix}.url`,
  };
}

/** paths 已完整时直接使用，否则按 options 解析（独立引用场景） */
export function coerceImagePaths(rawPaths?: Record<string, string>, options?: ImageBlockOptions): ImagePaths {
  if (rawPaths?.imagePrefix && rawPaths?.imageKey && rawPaths?.imageUrl) {
    return rawPaths as ImagePaths;
  }
  const pathPrefix = rawPaths?.pathPrefix ?? '';
  const resolved = resolveImagePaths(pathPrefix, options);
  return {
    ...resolved,
    ...(rawPaths?.imagePrefix ? { imagePrefix: rawPaths.imagePrefix } : {}),
    ...(rawPaths?.imageKey ? { imageKey: rawPaths.imageKey } : {}),
    ...(rawPaths?.imageUrl ? { imageUrl: rawPaths.imageUrl } : {}),
  };
}
